import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Link, useNavigate } from "react-router-dom";
import Actions from "components/Car/Actions";
import { formatDateMonthYear } from "utils/helpers/format";
import { useAuth } from "hooks/useAuth";

const useColumns = (setProduct, handleModalOpen, fetchData) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const { role } = useAuth();

  const navigate = useNavigate();
  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    // {
    //   Header: "",
    //   accessor: "checkbox",
    //   width: "50px",
    //   disableSortBy: true,
    //   Cell: ({ row }) => (
    //     <Checkbox
    //       checked={selected[row.values.id] || false}
    //       onChange={() => handleCheckboxChange(row.values.id)}
    //     />
    //   ),
    // },
    { Header: "รหัส MID", accessor: "mid", showInFilter: false },
    {
      Header: "ชื่อร้าน/บริษัท",
      accessor: "company_name",
      width: "250px",
      showInFilter: false,
    },
    { Header: "ผู้ติดต่อ", accessor: "contact", showInFilter: false },
    { Header: "เบอร์โทรศัพท์", accessor: "phone", showInFilter: false },
    {
      Header: "โรงรับจำนำ",
      accessor: "package_pawn",
    },
    {
      Header: "รถมือสอง",
      accessor: "package_car",
    },
    {
      Header: "ที่ดิน",
      accessor: "package_land",
    },
    { Header: "สถานะ", accessor: "company_status", showInFilter: false },
    // { Header: "อนุมัติ", accessor: "approved", showInFilter: false },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      width: "50px",
      Cell: ({ row }) => (
        <>
          <Actions
            menuList={[
              {
                label: "ดูรายละเอียด",
                icon: <RemoveRedEyeIcon style={{ color: "#737373" }} />,
                onClick: () => {
                  navigate(`detail/${row.company_id}`);
                  handleMenuClose();
                },
              },
              ...(role !== "SuperAdminA"
                ? [
                    {
                      label: "แก้ไข",
                      icon: <BorderColorIcon style={{ color: "#737373" }} />,
                      onClick: () => {
                        console.log("row", row);
                        setProduct(row);
                        handleModalOpen();
                        handleMenuClose();
                      },
                    },
                  ]
                : []),
              {
                label: "พิมพ์ใบรับซื้อสินค้า",
                icon: <LocalPrintshopIcon style={{ color: "#737373" }} />,
                onClick: () => {
                  // Handle print action here
                  handleMenuClose();
                },
              },
            ]}
            handleMenuOpen={(event) => handleMenuOpen(event, row.id)}
          />

          {/* <div>
            <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && activeRowId === row.id}
              onClose={handleMenuClose}
            >
              <MenuItem>
                <Link
                  to={`detail/${row.company_id}/${row.company_package_id}`}
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <RemoveRedEyeIcon
                    style={{ marginRight: "8px", color: "#737373" }}
                  />

                  <span style={{ marginLeft: "8px", color: "#737373" }}>
                    ดูรายละเอียด
                  </span>
                </Link>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  // console.log("row", row);
                  setProduct(fetchData[row.id]);
                  handleModalOpen();
                  handleMenuClose();
                }}
              >
                <BorderColorIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  แก้ไข
                </span>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                }}
              >
                <LocalPrintshopIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  พิมพ์ใบรับซื้อสินค้า
                </span>
              </MenuItem>
            </Menu>
          </div> */}
        </>
      ),
    },
  ];

  return columns;
};

export default useColumns;
